module.exports = __webpack_public_path__ + "img/company-logo-sofiagardens.6a1a4da2.svg";